export default "__VITE_ASSET__CMvrRZ1U__"